import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { css, up, styled } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';

import { withSettings } from 'containers/WebApp/SettingsContext';
import Logo from './images/footer-logo-@2x.png';

const FooterWrapper = styled.footer`
  background-color: #000;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 1rem 0 1rem 0;
  ${up(
    'md',
    css`
      flex-direction: row;
      justify-content: space-between;
    `
  )};
  p {
    color: #fff;
    font-size: 16px;
  }
  ul {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${up(
      'md',
      css`
        flex-direction: row;
        height: 30px;
        align-items: center;
      `
    )};
  }
  li {
    font-size: 14px;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    ${up(
      'md',
      css`
        border-right: 1px solid #fff;
        padding: inherit;
        text-align: left;
        &:nth-last-child(1) {
          border-right: none;
        }
      `
    )};
    a {
      color: #fff;
      text-decoration: none;
      padding: 0.1rem 1rem;
      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  .footer-right-text {
    padding: 0 1rem;
  }
`;

const Footer = ({ siteName }) => (
  <FooterWrapper>
    <FooterContainer>
      <div className="text--center footer-right-text">
        <img src={Logo} alt="Harman" width="281" />
      </div>
      <ul>
        <li>
          <Link to="/terms">Terms & Conditions</Link>
        </li>
        <li>
          <Link to="/privacy">Privacy Policy</Link>
        </li>
      </ul>
    </FooterContainer>
  </FooterWrapper>
);

Footer.propTypes = {
  siteName: PropTypes.string,
};

Footer.defaultProps = {
  siteName: 'Lori Program Default',
};

export default withSettings(Footer);
